import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import FiltrosServicios from "../../componentesEspeciales/serviciosAdmin/filtrosServicios";
import ListaServicios from "../../componentesEspeciales/serviciosAdmin/listaServicios";

function ServicioIndividualCate() {
    const navigate      = useNavigate();
    const { state }     = useLocation();
    const cat           = state?.params?.categoria || null;

    const [tab, setTab]             = useState("Borrador");
    const [pagina, setPagina]       = useState(1);
    const [servicios, setServicios] = useState([]);
    const [cargando, setCargando]   = useState(false);
    const [filtros, setFiltros]     = useState({
        falta1: false,
        paso1: false, paso2: false, paso3: false, paso4: false, paso5: false,
        sinWA: false, sinEmail: false, sinApp: false, sinTelefono: false,
        esDigital: false, esPresencial: false, esUrgente: false,
    });

    const POR_PAGINA = 15;

    function paso1OK(s) {
        if (s.tipoServicio === "Digital") return true;
        if (s.tipoServicio === "Presencial") return ["Domicilio", "EnLocal", "Ambos"].includes(s.tipoDesplazamiento);
        return false;
    }
    function paso2OK(s) {
        const nombre = (s.nombre || "").trim();
        const desc   = (s.descripcion || "").trim();
        const cat    = (s.categoria || "").trim();
        const sub    = (s.subcategoria || "").trim();
        return nombre.length >= 5 && nombre !== "NA"
            && desc.length >= 15 && desc !== "NA"
            && cat && cat !== "NA"
            && sub && sub !== "NA";
    }
    function paso3OK(s) { return Array.isArray(s.imagenes) && s.imagenes.length >= 1; }
    function paso4OK(s) { return Array.isArray(s.paquetes) && s.paquetes.length >= 1; }
    function paso5OK(s) { return Array.isArray(s.faq) && s.faq.length >= 1; }
    function aplicarFiltros(lista) {
        return lista.filter(s => {
            if (filtros.falta1) {
                const incompletos = [paso1OK, paso2OK, paso3OK, paso4OK, paso5OK].filter(fn => !fn(s)).length;
                if (incompletos !== 1) return false;
            }
            if (filtros.paso1 && paso1OK(s)) return false;
            if (filtros.paso2 && paso2OK(s)) return false;
            if (filtros.paso3 && paso3OK(s)) return false;
            if (filtros.paso4 && paso4OK(s)) return false;
            if (filtros.paso5 && paso5OK(s)) return false;
            const r = s.recordatorioEnviado || {};
            if (filtros.sinWA       && r.whatsapp)  return false;
            if (filtros.sinEmail    && r.klaviyo)   return false;
            if (filtros.sinApp      && r.pushApp)   return false;
            if (filtros.sinTelefono && r.telefono)  return false;
            if (filtros.esDigital    && s.tipoServicio !== "Digital")    return false;
            if (filtros.esPresencial && s.tipoServicio !== "Presencial") return false;
            if (filtros.esUrgente    && !s.urgente) return false;
            return true;
        });
    }

    const FILTROS_VACIO = { falta1: false, paso1: false, paso2: false, paso3: false, paso4: false, paso5: false, sinWA: false, sinEmail: false, sinApp: false, sinTelefono: false, esDigital: false, esPresencial: false, esUrgente: false };

    function cambiarTab(nuevoTab) {
        setTab(nuevoTab);
        setPagina(1);
        if (nuevoTab !== "Borrador") {
            setFiltros(f => ({ ...FILTROS_VACIO, esDigital: f.esDigital, esPresencial: f.esPresencial, esUrgente: f.esUrgente }));
        }
    }

    function cambiarFiltros(f) { setFiltros(f); setPagina(1); }

    useEffect(() => {
        if (!cat?.categoria && !cat?.sinCategoria) return;
        (async () => {
            try {
                setCargando(true);
                const params = cat.sinCategoria
                    ? { sinCategoria: true }
                    : { categoria: cat.categoria };
                const res = await axios.post("/servicios-por-categoria-admin", { params });
                setServicios(res.data.servicios || []);
            } catch { setServicios([]); }
            finally { setCargando(false); }
        })();
    }, [cat?.categoria, cat?.sinCategoria]);

    if (!cat) {
        return (
            <div className="container-fluid">
                <div className="pt-3 pb-2 mb-4 border-bottom">
                    <h1 className="h2 text-dark mb-1">Categoría</h1>
                </div>
                <div className="border rounded-4 p-5 bg-light text-center">
                    <p className="text-muted small mb-0">No se encontró información de la categoría.</p>
                </div>
            </div>
        );
    }

    const esSinCategoria = !!cat.sinCategoria;

    const borradores   = aplicarFiltros(servicios.filter(s => s.estado === "Borrador"));
    const aprobados    = aplicarFiltros(servicios.filter(s => s.estado === "Aprobado"));
    const desaprobados = aplicarFiltros(servicios.filter(s => s.estado === "Desaprobado"));
    const pausados     = aplicarFiltros(servicios.filter(s => s.estado === "Pausado"));
    const lista        = tab === "Borrador" ? borradores : tab === "Aprobado" ? aprobados : tab === "Desaprobado" ? desaprobados : pausados;
    const totalPaginas = Math.ceil(lista.length / POR_PAGINA);
    const listaPage    = lista.slice((pagina - 1) * POR_PAGINA, pagina * POR_PAGINA);

    return (
        <div className="container-fluid">
            <div className="pt-3 pb-2 mb-4 border-bottom">
                <div className="d-flex align-items-center gap-3 flex-wrap">
                    <div className="d-flex align-items-center gap-3">
                        {esSinCategoria ? (
                            <div className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                                style={{ width: 32, height: 32, background: "rgba(var(--amarillo-warning-rgb), 0.15)" }}>
                                <i className="bi bi-question-circle" style={{ color: "var(--dorado)", fontSize: 18 }}></i>
                            </div>
                        ) : cat.icono ? (
                            <img src={cat.icono} alt={cat.categoria}
                                style={{ width: 32, height: 32, objectFit: "contain", opacity: 0.8 }} />
                        ) : null}
                        <div>
                            <h1 className="h2 text-dark mb-0">{esSinCategoria ? "Sin categoría" : cat.categoria}</h1>
                            <p className="text-muted mb-0 small">
                                {borradores.length + aprobados.length + desaprobados.length} servicio{borradores.length + aprobados.length + desaprobados.length !== 1 ? "s" : ""}
                                {esSinCategoria && " · sin categoría asignada"}
                            </p>
                        </div>
                    </div>
                    <button
                        className="btn btn-outline-secondary btn-sm rounded-3 ms-auto flex-shrink-0"
                        onClick={() => navigate(-1)}
                    >
                        <i className="bi bi-arrow-left me-1"></i>Categorías
                    </button>
                </div>
            </div>

            {/* Filtros por paso */}
            <div className="mb-3">
                <FiltrosServicios filtros={filtros} onChange={cambiarFiltros} tab={tab} />
            </div>

            {/* Tabs */}
            <ul className="nav nav-tabs mb-4">
                <li className="nav-item">
                    <button
                        className={`nav-link ${tab === "Borrador" ? "active fw-semibold" : ""}`}
                        onClick={() => cambiarTab("Borrador")}
                    >
                        <i className="bi bi-pencil-square me-1"></i>Borrador
                        {borradores.length > 0 && (
                            <span className="badge bg-primary rounded-pill ms-2" style={{ fontSize: "0.7rem" }}>{borradores.length}</span>
                        )}
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${tab === "Aprobado" ? "active fw-semibold" : ""}`}
                        onClick={() => cambiarTab("Aprobado")}
                    >
                        <i className="bi bi-check-circle me-1"></i>Aprobado
                        {aprobados.length > 0 && (
                            <span className="badge bg-primary rounded-pill ms-2" style={{ fontSize: "0.7rem" }}>{aprobados.length}</span>
                        )}
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${tab === "Desaprobado" ? "active fw-semibold" : ""}`}
                        onClick={() => cambiarTab("Desaprobado")}
                    >
                        <i className="bi bi-x-circle me-1"></i>Desaprobado
                        {desaprobados.length > 0 && (
                            <span className="badge bg-danger rounded-pill ms-2" style={{ fontSize: "0.7rem" }}>{desaprobados.length}</span>
                        )}
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${tab === "Pausado" ? "active fw-semibold" : ""}`}
                        onClick={() => cambiarTab("Pausado")}
                    >
                        <i className="bi bi-pause-circle me-1"></i>Pausado
                        {pausados.length > 0 && (
                            <span className="badge bg-secondary rounded-pill ms-2" style={{ fontSize: "0.7rem" }}>{pausados.length}</span>
                        )}
                    </button>
                </li>
            </ul>

            {/* Contenido */}
            <ListaServicios
                servicios={listaPage}
                total={lista.length}
                paginas={totalPaginas}
                pagina={pagina}
                onCambiarPagina={setPagina}
                onClickVer={s => navigate("/admin/servicio", { state: { params: { idServicio: s.idServicio } } })}
                cargando={cargando}
            />
        </div>
    );
}

export default ServicioIndividualCate;
